import * as React from 'react';

import { debounce } from 'lodash/fp';
import { compose, defaultProps, mapProps } from 'recompose';

import Input from './Input';

type Props = React.ComponentProps<typeof Input> & {
    initialValue?: string;
    debounceBy?: number;
    onDebounce?: (value: string) => void;
};

const enhance = compose<Props, Props>(
    defaultProps({ initialValue: '', debounceBy: 250 }),
    mapProps(({ onDebounce, debounceBy, ...props }: Props) => ({
        onDebounce: debounce(debounceBy, (value: string) => {
            onDebounce && onDebounce(value);
        }),
        ...props,
    }))
);

const InputWithDebounce: React.FC<Props> = ({
    initialValue,
    onDebounce,
    value,
    onChange,
    ...props
}) => {
    const [innerValue, setInnerValue] = React.useState(initialValue || '');

    const handleInnerChange = (ev: any) => {
        setInnerValue(ev.currentTarget.value);
        onDebounce && onDebounce(ev.currentTarget.value);
    };

    React.useEffect(() => {
        setInnerValue(initialValue);
    }, [initialValue]);

    return <Input value={innerValue} onChange={handleInnerChange} {...props} />;
};

export default enhance(InputWithDebounce);
